import React, { useState } from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header';
import Footer from './Footer';
import AuthModal from '@/components/Auth/AuthModal';
import EmailVerificationBanner from '@/components/EmailVerificationBanner';
import { useAuth } from '@/context/AuthContext';

const MainLayout = () => {
  const { currentUser } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [authModalOpen, setAuthModalOpen] = useState(false);
  const [pendingNavigation, setPendingNavigation] = useState(null);
  
  // Check if on verify-email page
  const isVerifyEmailPage = location.pathname === '/verify-email';
  
  // Show banner if user is logged in and email not verified (but not on verify page)
  const showBanner = currentUser && 
                     !currentUser.emailVerified && 
                     !isVerifyEmailPage;

  const handleProfileClick = (item) => {
    if (item.requiresAuth && !currentUser) {
      // Show auth modal if not logged in and store intended destination
      setPendingNavigation(item.path);
      setAuthModalOpen(true);
    } else {
      // Navigate to the page if logged in
      navigate(item.path);
    }
  };

  const handleAuthSuccess = () => {
    setAuthModalOpen(false);
    // Only navigate if there was a pending navigation, otherwise stay on current page
    if (pendingNavigation) {
      navigate(pendingNavigation);
      setPendingNavigation(null);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      <Sidebar 
        isOpen={sidebarOpen} 
        onClose={() => setSidebarOpen(false)}
        onProfileClick={handleProfileClick}
      />
      <div className="sm:ml-24 flex flex-col min-h-screen">
        <Header 
          onMenuClick={() => setSidebarOpen(true)} 
          onLoginClick={() => setAuthModalOpen(true)}
          showEmailBanner={showBanner}
          emailBannerComponent={showBanner && (
            <EmailVerificationBanner 
              userEmail={currentUser.email}
              onDismiss={() => {}}
            />
          )}
        />
        <main className="pt-16 flex-1">
          <Outlet />
        </main>
        <Footer />
      </div>
      
      {/* Auth Modal */}
      <AuthModal 
        open={authModalOpen} 
        onClose={() => setAuthModalOpen(false)}
        onSuccess={handleAuthSuccess}
      />
    </div>
  );
};

export default MainLayout;